import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import TypeBadge from './TypeBadge';

function PokemonCard({ pokemon, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden group"
    >
      <Link to={`/pokemon/${pokemon.name}`} className="block focus:ring-2 focus:ring-blue-500 rounded-lg">
        <div className="relative p-4">
          {/* Pokemon Image */}
          <div className="flex justify-center mb-4">
            <img
              src={pokemon.image}
              alt={`${pokemon.displayName} official artwork`}
              className="w-24 h-24 object-contain group-hover:scale-110 transition-transform duration-300"
              loading="lazy"
            />
          </div>
          
          {/* Pokemon Info */}
          <div className="text-center">
            <h3 className="text-lg font-semibold text-gray-900 mb-1 group-hover:text-blue-600 transition-colors">
              {pokemon.displayName}
            </h3>
            <p className="text-sm text-gray-500 mb-3">#{pokemon.id.toString().padStart(3, '0')}</p>
            
            {/* Types */}
            <div className="flex justify-center space-x-1 mb-3">
              {pokemon.types.map((type) => (
                <TypeBadge key={type} type={type} size="sm" />
              ))}
            </div>
            
            {/* Base Stats Preview */}
            <div className="grid grid-cols-3 gap-2 text-xs">
              <div className="text-center">
                <div className="font-semibold text-red-600">{pokemon.baseStats.hp}</div>
                <div className="text-gray-500">HP</div>
              </div>
              <div className="text-center">
                <div className="font-semibold text-orange-600">{pokemon.baseStats.attack}</div>
                <div className="text-gray-500">ATK</div>
              </div>
              <div className="text-center">
                <div className="font-semibold text-blue-600">{pokemon.baseStats.speed}</div>
                <div className="text-gray-500">SPD</div>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}

export default PokemonCard;